import { CategoryAreaPinComponentSettings } from '@lessonup/pins-shared';
import { borderRadius, color } from '@lessonup/ui-components';
import { addImageSizing } from '@lessonup/utils';
import { colorSets } from '../../foundations/colorSets/colorSets';

type CategorySettings = CategoryAreaPinComponentSettings['categories'][number];

export interface CategoryStylesProps {
  categoryStyle?: CategorySettings['style'];
  active: boolean;
  placeholderText: string;
}

export function computeCategoryStyles({
  categoryStyle,
  active,
  placeholderText,
}: CategoryStylesProps): React.CSSProperties {
  return {
    '--category-placeholder-text': `"${placeholderText}"`,
    color: categoryStyle?.color,
    '--category-background-color': categoryStyle?.backgroundColor,
    '--category-border-width': `${categoryStyle?.borderSize || 1}px`,
    '--category-border-style': categoryStyle?.borderStyle || 'solid',
    '--category-border-color':
      categoryStyle?.borderColor || (active ? colorSets.active.on : color.neutral.outline.background),
    '--category-border-radius':
      categoryStyle?.borderRadius !== undefined ? `${categoryStyle.borderRadius}px` : borderRadius.rounded8,
    ...(categoryStyle?.backgroundImage && {
      '--category-background-image': `url(${addImageSizing({ url: categoryStyle.backgroundImage, size: 'm' })})`,
    }),
  } as React.CSSProperties;
}
